import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import SaveIcon from "@mui/icons-material/Save";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Delete from "@mui/icons-material/Delete";
import LayerFormFields from "../Feature/FeatureFormFields";
import EditFiles from "./EditFiles";
import { Stack } from "@mui/material";
import ImageWithRectangles from "./ImagesShow";
import AiDialog from "./AiDialog";
import ImagesDraw from "./ImagesDraw";

export default function EditDialog(props) {
  const [imageUrl, setImageUrl] = React.useState("");
  const [isScanOpen, setIsScanOpen] = React.useState(false);
  const [text, setText] = React.useState("");
  const [fieldName, setFieldName] = React.useState("");
  const [characterLimit, setCharacterLimit] = React.useState(1000);
  const [isAiOpen, setIsAiOpen] = React.useState(false);
  const [isDrawOpen, setIsDrawOpen] = React.useState(false);
  const [drawId, setDrawId] = React.useState("");

  const onScanPic = async (id) => {
    const pic = props.editFiles.find((obj) => obj.id === id);
    setImageUrl(pic.file);
    setIsScanOpen(true);
  };

  const onDrawPic = async (id) => {
    const pic = props.editFiles.find((obj) => obj.id === id);
    setImageUrl(pic.file);
    setIsDrawOpen(true);
    setDrawId(id);
  };

  const onAi = (text, fieldName, limit) => {
    setText(text);
    setFieldName(fieldName);
    setCharacterLimit(limit);
    setIsAiOpen(true);
  };

  const onScanClose = () => {
    setIsScanOpen(false);
    setImageUrl("");
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={props.isOpen}
        onClose={props.onClose}
        scroll={"paper"}
      >
        <DialogTitle style={{ paddingTop: 0, paddingBottom: 0 }}>
          {props.importTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{props.importSubtitle}</DialogContentText>

          <Box
            noValidate
            component="form"
            sx={{
              // display: "flex",
              flexDirection: "column",
              m: "auto",
              width: "100%",
              flexGrow: 1,
            }}
          >
            <LayerFormFields
              className="higher"
              feature={props.feature}
              schema={props.schema}
              onChange={props.onChange}
              onDateTimePickerChange={props.onDateTimePickerChange}
              save={props.save}
              cancel={props.cancel}
              onAi={onAi}
            />

            {props.allowFiles && (
              <EditFiles
                editFiles={props.editFiles}
                getAcceptedFiles={props.getAcceptedFiles}
                onEditFileCommentChange={props.onEditFileCommentChange}
                onRemoveEditFile={props.onRemoveEditFile}
                onScanPic={onScanPic}
                onDrawPic={onDrawPic}
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Stack>
            <Typography color="error">{props.formErrorMessage}</Typography>
            <Stack direction={"row"} spacing={1}>
              {props.importSubtitle !==
                "Import Successful: Results shown below" && (
                <Button startIcon={<ArrowBackIcon />} onClick={props.onClose}>
                  Cancel
                </Button>
              )}
              <Button
                startIcon={<SaveIcon />}
                variant="contained"
                disabled={
                  props.isLoading
                    ? true
                    : props.formErrorMessage.length === 0
                      ? false
                      : true
                }
                onClick={props.onEditSave}
              >
                Save
              </Button>
              {props.feature &&
                props.feature.hasOwnProperty("id") &&
                props.feature.id !== "new" &&
                props.allowDelete && (
                  <Button
                    startIcon={<Delete />}
                    variant="contained"
                    disabled={!props.allowDeleteAccess}
                    color="error"
                    onClick={props.onEditDelete}
                  >
                    Delete
                  </Button>
                )}
            </Stack>
          </Stack>
        </DialogActions>
      </Dialog>

      {isAiOpen && (
        <AiDialog
          isOpenAI={isAiOpen}
          onCloseAI={() => setIsAiOpen(false)}
          text={text}
          fieldName={fieldName}
          characterLimit={characterLimit}
          onChange={props.onChange}
        />
      )}

      {imageUrl.length > 0 && isScanOpen && (
        <ImageWithRectangles
          isScanOpen={isScanOpen}
          onScanClose={onScanClose}
          imageUrl={imageUrl}
        />
      )}

      {isDrawOpen && (
        <ImagesDraw
          isDrawOpen={isDrawOpen}
          onDrawClose={() => setIsDrawOpen(false)}
          imageUrl={imageUrl}
          drawId={drawId}
          onDrawComplete={props.onDrawComplete}
          
       
         
        />
      )}
    </div>
  );
}
